<template>
  <div
    class="volume-adjust"
    :style="{
      top: boxData.fix.y + 'px',
      left: boxData.fix.x + 'px',
      'z-index': boxData.Zindex,
    }"
    @mousedown="stopDocument($event)"
  >
    <audio
      ref="audioClip"
      id="vol-bgm-audio"
      style="display: none"
      :src="$handleAssetsUrl(getMusic.url)"
      @loadedmetadata="getAudioLengthSet"
      controls
      :volume="getTimeBarType == 'bgm' ? getMusicVolume : getDubbingVolume"
    ></audio>
    <div
      class="header"
      @mousedown="moveStart($event, true)"
      @mousemove="moveArea($event)"
      @mouseup="saveMoveState($event)"
      :style="{ cursor: 'move' }"
    >
      <span>音频剪辑</span>
      <i @click="closeClip" class="icon-popup-close"></i>
    </div>
    <div @mouseup="timeBarMoveState()" class="volume-container">
      <transition name="slide-fade">
        <div class="cropSoundBox">
          <div class="clipTitle" style="margin-bottom: 50px; text-align: left">
            <span style="margin-right: 5px" class="iconfont iconyinle"></span>
            {{ getMusic.title }}
          </div>
          <div class="cropTool">
            <div class="cropBtnBox">
              {{ cropSound.isPlay }}
              <div
                @click="
                  cropPlaySound();
                  materialPushAnalysis({ type: 'cropSoundListen' });
                "
                class="cropBtn iconfont"
                :class="[
                  cropSound.play == false ? 'play-btn-play' : 'play-btn-pause', //play-btn-play
                ]"
              ></div>
            </div>
            <div
              class="scaleBar"
              @mousemove="timeBarMoveArea($event)"
              ref="scaleBarEl"
            >
              <div
                class="scaleBarBg"
                :style="{
                  width: cropSound.scaleBar.width + 'px',
                  left: cropSound.scaleBar.pox + 'px',
                }"
              ></div>

              <div
                class="scaleBarBtn"
                :style="{
                  width: cropSound.scaleBar.width + 'px',
                  left: cropSound.scaleBar.pox + 'px',
                }"
              >
                <div v-if="!cropSound.play" class="timeIconLeft">
                  <span>{{ millisecondFormat(cropSound.startTime) }}</span>
                </div>
                <div
                  v-if="!cropSound.play"
                  ref="timeIconRight"
                  class="timeIconRight"
                >
                  <span>{{ millisecondFormat(cropSound.endTime) }}</span>
                </div>
                <div
                  class="scaleBarBtnLeft el-icon-arrow-left"
                  v-dragged="onDraggedLeft"
                  :style="{
                    'z-index': cropSound.scaleBar.pox >= 340 ? 10 : 0,
                  }"
                  ref="scaleBarBtnLeft"
                ></div>
                <div
                  class="scaleBarBtnRight el-icon-arrow-right"
                  v-dragged="onDraggedRight"
                  :style="{
                    'z-index':
                      cropSound.scaleBar.width <= minClipTime &&
                      cropSound.scaleBar.pox <= 340
                        ? 10
                        : 0,
                  }"
                  ref="scaleBarBtnRight"
                ></div>
              </div>
              <div
                @mousedown="timeBarMoveStart($event, true)"
                @mouseup="timeBarMoveState($event)"
                v-if="cropSound.play"
                class="timeBar"
                :style="{
                  left: cropSound.playPox + 'px',
                }"
              >
                <span>{{ musicTimeConverter(cropSound.playCurrentTime) }}</span>
              </div>
            </div>
            <div class="soundDuration">
              {{ millisecondFormat(clipMusicDuration) }}
            </div>
          </div>
        </div>
      </transition>

      <div class="operate-btn">
        <el-button size="small" class="cancelClip" @click="closeClip"
          >取消</el-button
        >
        <el-button size="small" class="determineClip" @click="cutSoundtrack()"
          >确定</el-button
        >
      </div>
    </div>
  </div>
</template>
  
  <script>
import { mapGetters } from "vuex";
import popup from "../../mixins/popup";
import Analysis from "../../mixins/analysis/materialBu";
import audioPlay from "@/components/emodal/templateLib/contents/audioPlay.vue";

export default {
  mixins: [popup, Analysis, audioPlay],
  data() {
    return {
      minClipTime: 1, //最小剪辑音频时长
      clipMusicDuration: 0, //当前音乐的时长
      isPlay: false,
      // startTime: 0, // 场景页开始时间
      // endTime: 0, // 场景页结束时间
      // currentTime: 0, // 背景音乐
      boxData: {
        judgeBox: false, // 控制盒子开启关闭
        Zindex: 0, // 盒子层级
        data: null, // 盒子数据
        moveoks: false, // 拖动判读啊数据
        oldMove: {
          // 计算移动增量
          x: 0,
          y: 0,
        },
        fix: {
          // 弹窗位置
          x: 0,
          y: 0,
        },
      },
      // volBGM: "", // 背景音乐audio标签
      // volRec: "", // 录音audio标签
      playAll: false,
      bgmCurrent: 0,
      recCurrent: 0,
      cropSound: {
        // 剪辑音乐
        moveoks: false, // 移动启动
        pagexL: 0, // 左箭头坐标
        pagexR: 0, // 右箭头坐标
        AllWidth: 350, // 剪辑条外部长度
        scaleBar: {
          // 播放区域的宽和定位
          width: 0, //初始化的时候剪辑条的长度350全长
          pox: 0, //剪辑条的坐标
        },
        startTime: 0, //剪辑条的开始时间
        endTime: 0, //剪辑条结束时间
        play: false, //剪辑条内是否播放
        playPox: 0, //剪辑条内指针坐标
        playCurrentTime: 0, //指针播放当前时间
      },
      timeBarState: false, //指针启动移动状态
      timeBar: {
        //剪辑条内指针拖拽的坐标
        startX: 0, //拖拽的时候剪辑条的开始坐标
        endX: 0, //拖拽的时候剪辑条的结束坐标
        x: 0,
        y: 0,
      },
    };
  },
  computed: {
    ...mapGetters({
      getMusic: "soundtrackSet/getCutMusic", //当前剪辑的音乐
      getTimeBarType: "addSoundtrack/getTimeBarType", //当前剪辑音乐的类型
      getMusicIndex: "addSoundtrack/getMusicIndex",
      getMusicVolume: "addSoundtrack/getMusicVolume",
      getDubbingVolume: "addSoundtrack/getDubbingVolume",
      getPlayHandle: "addSoundtrack/getPlayHandle",
      getTotalTime: "addSoundtrack/getTotalTime"
    }),
  },
  created() {
    // 初始化弹窗的位置
    this.boxData.fix.x = document.documentElement.clientWidth / 2 - 250; //2为50%
    this.boxData.fix.y = document.documentElement.clientHeight / 2 - 150;
    // console.log("当前剪切音频",this.getMusic);
  },
  watch: {
    "boxData.judgeBox"(val) {
      if (!val) {
        // 关闭弹窗后停止播放
        this.endPlay();
      }
    },
  },
  mounted() {
    this.$bus.on("Document_mousemove_vue", (event) => {
      let e = event ? event : window.event;
      if (this.boxData.moveoks) {
        this.moveArea(e);
        return false;
      }
    });
    this.$bus.on("Document_mouseup_vue", (event) => {
      let e = event ? event : window.event;
      if (this.boxData.moveoks) {
        this.saveMoveState(e);
        return false;
      }
    });
    this.$bus.on("stop_sound_vue", () => {
      this.isPlay = false;
    });
    this.$bus.on("SoundScenesCurrentTime", (data) => {
      this.recCurrent = data.time;
    });
    this.$bus.on("SoundBGCurrentTime", (data) => {
      this.bgmCurrent = data.time;
    });
  },
  methods: {
    initClipWidth() {
      this.cropSound.startTime = this.getMusic.cut[0];
      this.cropSound.endTime = this.getMusic.cut[1];
      this.cropSound.scaleBar.pox =
        (this.cropSound.startTime / this.clipMusicDuration) *
        this.cropSound.AllWidth; //初始化进来定位到上次剪辑的位置
      this.cropSound.scaleBar.width =
        ((this.cropSound.endTime - this.cropSound.startTime) /
          this.clipMusicDuration) *
        this.cropSound.AllWidth; //获取上次剪辑的长度
    },
    getAudioLengthSet() {
      this.clipMusicDuration = this.$refs.audioClip.duration;
      this.initClipWidth();
    },
    cutSoundtrack() {
      if (this.getTimeBarType == "bgm") {
        this.updateMusicClip();
        this.$bus.emit("replace_current_music", {
          event: "clip",
        });

      } else {
        this.updateDubbingClip();
        this.$bus.emit("replace_current_dubing", {
          event: "clip",
        });
      }
      this.closeClip();
    },
    updateMusicClip() {
      let endTime =
        this.getMusic.timeSlot[0] +
        (this.cropSound.endTime - this.cropSound.startTime);
      let music = {
        cut: [
          parseFloat(this.cropSound.startTime),
          parseFloat(this.cropSound.endTime),
        ],
      };
      let reData = {
        cut: this.$store.getters["addSoundtrack/getSelectMusic"].cut,
      };
       
      if (!this.getPlayHandle.musicLoop &&
        (this.cropSound.endTime - this.cropSound.startTime <
        this.getMusic.timeSlot[1] - this.getMusic.timeSlot[0]
      )) { 
        music.timeSlot = [this.getMusic.timeSlot[0], endTime];
        reData.timeSlot = this.$store.getters[
          "addSoundtrack/getSelectMusic"
        ].timeSlot;
      }
      reData = JSON.stringify(reData);
      this.$store.commit("addSoundtrack/updateMusic", {
        music,
      });
      this.$bus.emit("insert_subtitle_undo", {
        type: "updateMusic",
        data: {
          index: this.getMusicIndex,
          data: JSON.stringify(music),
          reData: reData,
        },
      });
    },
    updateDubbingClip() {
      let timeEnd =
        this.getMusic.timeSlot[0] +
        (this.cropSound.endTime - this.cropSound.startTime);
      let dubbing = {
        cut: [
          parseFloat(this.cropSound.startTime),
          parseFloat(this.cropSound.endTime),
        ],
      };
      let reData = {
        cut: this.getMusic.cut,
      };
      if (
        this.cropSound.endTime - this.cropSound.startTime <
        this.getMusic.timeSlot[1] - this.getMusic.timeSlot[0]
      ) {
        dubbing.timeSlot = [this.getMusic.timeSlot[0], timeEnd];
        reData.timeSlot = this.getMusic.timeSlot;
      }
      reData = JSON.stringify(reData);
      this.$store.commit("addSoundtrack/updateDubbing", {
        dubbing,
      });
      this.$bus.emit("insert_subtitle_undo", {
        type: "updateDubbing",
        data: {
          index: this.$store.getters["addSoundtrack/getDubbingIndex"],
          data: JSON.stringify(dubbing),
          reData: reData,
        },
      });
    },

    closeClip() {
      this.$store.commit("soundtrackSet/setsoundtrackClipState", false);
    },
    onDraggedLeft(params) {
      this.onDragged(params, "left");
    },
    onDraggedRight(params) {
      this.onDragged(params, "right");
    },
    onDragged(params, type) {
      let { first, last, clientX, clientY, deltaX } = params;
      let m = {
        pageX: clientX,
        pageY: clientY,
      };
      if (first) {
        this.cropMoveStart(m, type);
      }
      if (last) {
        this.cropSaveMoveState(m);
        this.cropSound.moveoks = false;
      }
      if (!this.cropSound.moveoks) {
        return;
      }
      let wayRect = this.cropSound.wayRect;
      let prevMoveIn = this.cropSound.moveIn;
      let d =
        (this.cropSound.AllWidth * this.minClipTime) / this.clipMusicDuration;
      let startEdge = this.cropSound.leftBtnPos + d;
      let endEdge = wayRect.right;
      if (type === "left") {
        startEdge = wayRect.left;
        endEdge = this.cropSound.rightBtnPos - d;
      }
      if (startEdge <= clientX && clientX <= endEdge) {
        this.cropSound.moveIn = true;
        if (this.cropSound.moveIn && prevMoveIn === false) {
          this.cropSound.pagexL = clientX;
        }
      } else {
        if (type === "left" && clientX >= endEdge) {
          this.cropSound.startTime =
            this.cropSound.endTime * 1 - this.minClipTime;
          this.cropSound.scaleBar.pox =
            (this.cropSound.startTime / this.clipMusicDuration) *
            this.cropSound.AllWidth;
          this.cropSound.scaleBar.width =
            (this.cropSound.AllWidth * this.minClipTime) /
            this.clipMusicDuration;
        }
        if (type === "left" && clientX <= startEdge) {
          this.cropSound.startTime = 0;
          this.cropSound.scaleBar.pox = 0;
          this.cropSound.scaleBar.width =
            (this.cropSound.AllWidth *
              (this.cropSound.endTime - this.cropSound.startTime)) /
            this.clipMusicDuration;
        }
        if (type === "right" && clientX <= startEdge) {
          this.cropSound.endTime =
            this.cropSound.startTime * 1 + this.minClipTime;
          this.cropSound.scaleBar.width =
            (this.cropSound.AllWidth * this.minClipTime) /
            this.clipMusicDuration;
        }
        if (type === "right" && clientX >= endEdge) {
          this.cropSound.endTime = this.clipMusicDuration;
          this.cropSound.scaleBar.width =
            (this.cropSound.AllWidth *
              (this.cropSound.endTime - this.cropSound.startTime)) /
            this.clipMusicDuration;
        }
        this.cropSound.moveIn = false;
      }
      this.cropMoveArea(m);
    },
    cropMoveStart(e, type) {
      this.cropSound.moveoks = type;
      this.cropSound.moveIn = true;
      if (this.cropSound.play) {
        this.cropPlaySound();
      }
      switch (type) {
        case "left":
          this.materialPushAnalysis({ type: "cropSoundBtnleft" });
          this.cropSound.pagexL = e.pageX;
          break;
        case "right":
          this.materialPushAnalysis({ type: "cropSoundBtnright" });
          this.cropSound.pagexR = e.pageX;
          break;
      }
      this.cropSound.wayRect = this.$refs.scaleBarEl.getBoundingClientRect();
      this.cropSound.leftBtnPos = this.$refs.scaleBarBtnLeft.getBoundingClientRect().right;
      this.cropSound.rightBtnPos = this.$refs.scaleBarBtnRight.getBoundingClientRect().left;
    },
    cropMoveArea(e) {
      // 拖动元素计算
      if (this.cropSound.moveIn) {
        switch (this.cropSound.moveoks) {
          case "left":
            let leftX = this.cropSound.pagexL - e.pageX;

            if (
              this.cropSound.scaleBar.width + leftX > 0 &&
              this.cropSound.scaleBar.pox >= 0 &&
              this.cropSound.scaleBar.pox - leftX >= 0
            ) {
              this.settingSoundData({
                startTime: this.cropSound.pagexL - e.pageX,
              });
              if (this.cropSound.scaleBar.pox - leftX == 0) {
                this.settingSoundData({
                  startTime: this.cropSound.scaleBar.pox,
                });
              }
            } else {
              if (this.cropSound.scaleBar.pox - leftX < 0) {
                this.settingSoundData({
                  startTime: this.cropSound.scaleBar.pox,
                });
              }
              this.cropSound.moveIn = false;
            }
            this.cropSound.pagexL = e.pageX;
            break;
          case "right":
            let rightX = e.pageX - this.cropSound.pagexR;
            if (
              this.cropSound.scaleBar.width + rightX > 0 &&
              this.cropSound.AllWidth >
                this.cropSound.scaleBar.width +
                  this.cropSound.scaleBar.pox +
                  rightX
            ) {
              this.settingSoundData({
                endTime: e.pageX - this.cropSound.pagexR,
              });
            } else {
              this.cropSound.scaleBar.width = 350 - this.cropSound.scaleBar.pox;
              this.cropSound.endTime = this.clipMusicDuration;
              this.cropSound.moveIn = false;
            }
            this.cropSound.pagexR = e.pageX;
            break;
        }
      }
    },
    cropSaveMoveState(e) {
      // 保存移动状态
      if (this.cropSound.moveoks) {
        this.cropSound.moveoks = false;
      }
    },
    // 指针拖拽
    timeBarMoveStart(e) {
      this.timeBarState = true;
      this.$refs.audioClip.pause();
      this.timeBar.x = e.pageX - this.cropSound.playPox;
      this.timeBar.startX =
        (this.cropSound.startTime / this.clipMusicDuration) *
        this.cropSound.AllWidth;
      this.timeBar.endX =
        (this.cropSound.endTime / this.clipMusicDuration) *
        this.cropSound.AllWidth;
    },
    timeBarMoveArea(e) {
      let startX = this.timeBar.startX;
      let endX = this.timeBar.endX;
      let playPox = 0;
      if (!this.timeBarState) return;
      if (
        e.pageX - this.timeBar.x > startX &&
        e.pageX - this.timeBar.x < endX
      ) {
        playPox = e.pageX - this.timeBar.x;
      } else if (
        e.pageX - this.timeBar.x < startX &&
        e.pageX - this.timeBar.x < endX
      ) {
        playPox = startX;
        // this.timeBarState = false;
        // this.$refs.audioClip.currentTime = this.cropSound.playCurrentTime;
        // this.$refs.audioClip.play();
      }
      if (
        e.pageX - this.timeBar.x < endX &&
        e.pageX - this.timeBar.x > startX
      ) {
        playPox = e.pageX - this.timeBar.x;
      } else if (
        e.pageX - this.timeBar.x > startX &&
        e.pageX - this.timeBar.x > endX
      ) {
        playPox = endX;
        // this.timeBarState = false;
        // this.$refs.audioClip.pause()
      }

      this.cropSound.playPox = playPox;
      this.cropSound.playCurrentTime =
        (this.cropSound.playPox / this.cropSound.AllWidth) *
        this.clipMusicDuration;
    },
    timeBarMoveState(e) {
      if (this.timeBarState) {
        let audioClip = this.$refs.audioClip;
        this.timeBarState = false;
        audioClip.currentTime = this.cropSound.playCurrentTime;
        this.$refs.audioClip.play();
      }
    },
    settingSoundData(data) {
      // 设置背景音乐位置
      let pox = this.cropSound.scaleBar.pox,
        width = this.cropSound.scaleBar.width;
      for (let itemAttr in data) {
        switch (itemAttr) {
          case "startTime":
            if (
              data[itemAttr] < 0 &&
              this.cropSound.endTime - this.cropSound.startTime <
                this.minClipTime
            )
              return;
            pox -= data[itemAttr];
            width += data[itemAttr];
            break;
          case "endTime":
            if (
              data[itemAttr] < 0 &&
              this.cropSound.endTime - this.cropSound.startTime <
                this.minClipTime
            )
              return;
            width += data[itemAttr];
            break;
        }
      }
      if (
        (
          ((pox + width) / this.cropSound.AllWidth) *
          this.clipMusicDuration
        ).toFixed(2) -
          ((pox / this.cropSound.AllWidth) * this.clipMusicDuration).toFixed(
            2
          ) >=
        this.minClipTime
      ) {
        this.cropSound.scaleBar.pox = pox;
        this.cropSound.scaleBar.width = width;
        this.cropSound.startTime = (
          (this.cropSound.scaleBar.pox / this.cropSound.AllWidth) *
          this.clipMusicDuration
        ).toFixed(2);
        this.cropSound.endTime = (
          ((this.cropSound.scaleBar.pox + this.cropSound.scaleBar.width) /
            this.cropSound.AllWidth) *
          this.clipMusicDuration
        ).toFixed(2);
        this.cropSound.endTime = Math.min(
          this.cropSound.endTime,
          this.clipMusicDuration
        );
      } else {
      }
      this.cropSound.scaleBar.width;
    },
    cropPlaySound(data) {
      let cropSoundDom = document.getElementById("vol-bgm-audio"),
        cropSoundDomFS = () => {
          // 播放时的操作
          if (cropSoundDom.currentTime >= this.cropSound.endTime) {
            cropSoundDom.pause();
            this.cropSound.play = false;
            cropSoundDom.currentTime = this.cropSound.startTime;
          } else {
            this.cropSound.playPox =
              (cropSoundDom.currentTime / duration) * this.cropSound.AllWidth;
            this.cropSound.playCurrentTime = cropSoundDom.currentTime;
          }
        };
      let duration = cropSoundDom.duration;
      // 点击播放按钮操作
      if (this.cropSound.play || data || !cropSoundDom.paused) {
        cropSoundDom.pause();
        this.cropSound.play = false;
      } else {
        // if (
        //   cropSoundDom.currentTime == 0 &&
        //   this.cropSound.playCurrentTime == 0 &&
        //   this.cropSound.playPox == 0
        // ) {
        cropSoundDom.currentTime = this.cropSound.startTime;
        this.cropSound.playCurrentTime = cropSoundDom.currentTime;
        this.cropSound.playPox =
          (cropSoundDom.currentTime / duration) * this.cropSound.AllWidth;
        // }
        if (this.cropSound.playCurrentTime >= this.cropSound.endTime) {
          cropSoundDom.currentTime = this.cropSound.startTime;
        }
        if (this.cropSound.playCurrentTime <= this.cropSound.startTime) {
          cropSoundDom.currentTime = this.cropSound.startTime;
        }

        cropSoundDom.addEventListener("timeupdate", cropSoundDomFS);
        cropSoundDom.play();
        this.cropSound.play = true;
      }
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.volume-adjust {
  position: fixed;
  width: 613px;
  height: 317px;
  z-index: 35;
  background: #fff;
  font-family: "Microsoft YaHei";
  font-size: 14px;
  color: #474261;
  overflow: hidden;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  border-radius: 4px;
  box-sizing: border-box;
  .header {
    position: relative;
    height: 48px;
    line-height: 28px;
    padding-top: 20px;
    text-align: center;
    span {
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #474261;
      font-size: 16px;
    }
    i {
      position: absolute;
      top: 16px;
      right: 16px;
      display: inline-block;
      width: 12px;
      height: 12px;
      cursor: pointer;
    }
  }
  .volume-container {
    position: relative;
    height: 270px;
    .operate-btn {
      position: absolute;
      bottom: 50px;
      left: 0;
      width: 100%;
      .determineClip {
        background-color: #5778fb;
        color: #fff;
        margin-left: 24px;
        &:hover {
          opacity: 0.8;
        }
      }
      .cancelClip {
        color: #737596;
        background-color: #fff;
        &:hover {
          opacity: 0.8;
        }
      }
      button {
        font-size: 14px;
        width: 120px;
        height: 40px;
      }
    }
    .audition {
      position: absolute;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 70px;
      color: #474261;
      background-color: #f8f8fe;
      .play,
      .stop {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        margin-left: 21px;
        margin-right: 13px;
        border-radius: 50%;
        cursor: pointer;
      }
      .play {
        background: url("/static/svg/play.svg") no-repeat center;
        &:hover {
          background: url("/static/svg/play-active.svg") no-repeat center;
        }
      }
      .stop {
        background: url("/static/svg/stop.svg") no-repeat center;
        &:hover {
          background: url("/static/svg/stop-active.svg") no-repeat center;
        }
      }
    }

    .cropSoundBox {
      position: absolute;
      top: 0;
      left: 0;
      background: #fff;
      width: 100%;
      z-index: 10;
      padding: 10px 60px;
      .clipTitle {
        color: #474261;
        font-family: Microsoft YaHei;
        font-weight: 500;
      }
      .arrowBtn {
        position: absolute;
        top: 16px;
        left: 30px;
        width: 100px;
        height: 36px;
        background-color: #f0f0f8;
        border-radius: 4px;
        color: #474261;
        cursor: pointer;
        line-height: 36px;

        .icon {
          vertical-align: baseline;
          margin-right: 3px;
          margin-bottom: -2px;
        }
      }
      .cropTool {
        display: flex;
        .scaleBar {
          position: relative;
          width: 350px;
          height: 40px;
          background: url(/static/img/timeBar.png) no-repeat center;
          background-size: contain;
          background-color: #f0f0f8;

          .scaleBarBg {
            position: absolute;
            top: 0;
            left: 0;
            width: 20px;
            height: 40px;
            background: url(/static/img/timeBarActive.png) no-repeat center;
            background-color: #d4d4f2;
            background-size: 335px auto;
          }

          .scaleBarBtn {
            position: absolute;
            top: 0;
            left: 0;
            width: 20px;
            height: 40px;
            border: solid 1px #5778fb;
            font-size: 12px;
            .scaleBarBtnLeft,
            .scaleBarBtnRight {
              position: absolute;
              top: -1px;
              width: 10px;
              height: 40px;
              background-color: #5778fb;
              border-radius: 4px 0 0 4px;
              cursor: pointer;
              color: #fff;
              line-height: 40px;
              text-indent: -2px;
            }
            .scaleBarBtnLeft {
              left: -10px;
            }
            .scaleBarBtnRight {
              right: -10px;
              border-radius: 0 4px 4px 0;
            }

            .timeIconRight,
            .timeIconLeft {
              position: absolute;
              width: 70px;
              height: 26px;
              color: #474261;

              span {
                position: absolute;
                top: 0;
                left: 0;
                width: 70px;
                height: 19px;
                border-radius: 9px;
              }
            }
            .timeIconLeft {
              text-align: left;
              left: -24px;
                top: -26px;
            }
            .timeIconRight {
              text-align: right;
              right: -30px;
              bottom: -26px;
            }
          }

          .timeBar {
            position: absolute;
            top: -3px;
            left: 0;
            width: 2px;
            height: 46px;
            cursor: pointer;
            background-color: #5778fb;

            span {
              position: absolute;
              top: -25px;
              left: -32px;
              width: 70px;
              height: 19px;
              border-radius: 9px;
            }
          }
        }
        .soundDuration {
          height: 40px;
          margin-left: 15px;
          line-height: 40px;
          color: #474261;
        }
      }
      .cropBtnBox {
        width: 64px;
        height: 69px;
        .cropBtn {
          width: 36px;
          height: 36px;
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center;
        }
        .play-btn-play {
          background-image: url(/static/svg/audioLibrary/bofang.svg);
        }

        .play-btn-pause {
          background-image: url(/static/svg/audioLibrary/bofang2.svg);
        }
      }
    }
  }
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.4s ease;
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(100px);
  opacity: 0;
}
</style>
  



// WEBPACK FOOTER //
// src/components/subtitle/soundtrack/soundClip.vue